// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import QRCode from '../../_common/api/QRCode';
import Button from '../../_common/form/Button';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import Modal from '../../_common/Modal';
import Card from '../Card';
import { HamQuest } from '../../../App';
import { QuestRoute } from '../../_common/api/QuestRoutes';

const Code = styled(Title)`
    color: red;
    font-weight: bold;
    line-height: 1;
    padding: 0.2em 0;
`

const Referral = ({ ...props }) => {
    const {
        state: {
            active_user,
            site_config,
        },
    } = useGlobalState();

    // const referralURL = `${window.location.origin}/signUp#${active_user.account.referralCode}`;

    const [referral, setReferral] = useState('')
    useLayoutEffect(() => {
        HamQuest.get(QuestRoute.merchant.referralPoints)
            .then(res => setReferral(res[0]?.value || 1000))
    }, [])

    const referralURL = `${window.location.origin}/storeDirect#${active_user.account.referralCode}`

    const shareCode = async () => {
        try {
            navigator.share({
                title: 'Referral Code',
                text: `Click here to download the ${site_config.companyName} App and sign up using the referral code: ${active_user.account.referralCode}\n${referralURL}`,
            })
        }
        catch (err) {
            console.log('Failed to share.', err)
        }
    }

    const shareLink = async (url) => {
        try {
            navigator.share({
                title: 'Referral Code',
                text: `Click here to download the ${site_config.companyName} App and sign up using the referral code: ${active_user.account.referralCode}\n${referralURL}`,
            })
        }
        catch (err) {
            console.log('Failed to share.', err)
        }
    }

    return (
        <Card>
            <Title icon='envelope'>Invite Your Friends!</Title>
            <div>
                Invite your friends and family to download our app and enter your referral code during sign up, you'll get {referral} Loyalty Points after they make their first purchase.
            </div>
            <b>Your Referral Code:</b>
            <Code>{active_user.account.referralCode}</Code>
            <Button onClick={() => shareLink()}>Share</Button>
            {/* {site_config.appStore.google ? <Button onClick={() => shareLink(site_config.appStore.google)}>Share for Android</Button> : null} */}
            {/* <Button onClick={shareCode}>Share</Button> */}
            <b>Or Have them scan:</b>
            <QRCode data={referralURL} />
        </Card>
    );
}

export default Referral; 